import { jsx as _jsx } from "react/jsx-runtime";
import { TriangleDown } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { FiltersMenu } from "~/components/FiltersMenu/FiltersMenu";
import { baseFiltersOptions } from "~/components/FiltersMenu/types";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
import { FILTER_SELECT_BTN } from "~/constants/testIDs";
import { changeFilterTypeAction } from "~/store/filters/actions";
export const FilterSelect = /*#__PURE__*/ memo((param)=>{
    let { getFiltersOptions, currentCustomField, currentFilter, onFilterSelect } = param;
    const dispatch = useDispatch();
    const onSelect = useCallback((type, customField)=>{
        dispatch(changeFilterTypeAction({
            newFilter: {
                type,
                customField
            },
            oldFilter: {
                type: currentFilter,
                customField: currentCustomField
            }
        }));
        onFilterSelect === null || onFilterSelect === void 0 ? void 0 : onFilterSelect(type, customField);
    }, [
        currentCustomField,
        currentFilter,
        dispatch,
        onFilterSelect
    ]);
    const options = useMemo(()=>getFiltersOptions(onSelect), [
        getFiltersOptions,
        onSelect
    ]);
    const trigger = useMemo(()=>{
        const filter = baseFiltersOptions[currentFilter];
        var _currentCustomField_name;
        const title = (_currentCustomField_name = currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.name) !== null && _currentCustomField_name !== void 0 ? _currentCustomField_name : filter.label;
        const Icon = (currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.type.title) ? customFieldIconMap[currentCustomField.type.title] : filter.icon;
        return /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            "data-testid": FILTER_SELECT_BTN,
            prefix: !!Icon && /*#__PURE__*/ _jsx(Icon, {
                className: "size-4"
            }),
            size: "medium",
            suffix: /*#__PURE__*/ _jsx(TriangleDown, {
                className: "size-4"
            }),
            children: /*#__PURE__*/ _jsx("span", {
                className: "truncate",
                children: title
            })
        });
    }, [
        currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.name,
        currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.type.title,
        currentFilter
    ]);
    return /*#__PURE__*/ _jsx(FiltersMenu, {
        options: options,
        trigger: trigger
    });
});
FilterSelect.displayName = "FilterSelect";
